import React, { Component } from 'react'

class bannerAircraftIsTest extends Component {
    render() {
        if (this.props.isTest !== true) {
            return "";
        }

        return (
            <div className="box box-notice box-solid">
                <div className="callout callout-notice">
                    <h4>
                        <i className="fa fa-info-circle" /> Notice
                    </h4>
                    Fake aircraft - This is a server created for testing purposes only,
                    typically installed at Display or customer offices.
                </div>
            </div>
        )
    }
}

export default bannerAircraftIsTest;
